import * as React from "react"
import { Link } from "react-router-dom"
import Card from "../../../card"
import { FooterItem, ButtonFooterItem } from "../../../card/footer-item"
import { LocalAuthority, Word } from "../../../../model";

class PolitiqueCardComponent  extends React.Component<PolitiqueCardComponentProps > {

	render() {
		return (
			<Card footerItems={this.getFooterItems(this.props)} loading={this.props.loading} paddingless title="Politique">
				<table className="is-fullwidth">
					{this.getTableBody(this.props)}
				</table>
			</Card>
		)
	}

	private getFooterItems(props: PolitiqueCardComponentProps ): FooterItem[] {
        return [	{
			content : "Voir plus",
			disabled: this.props.loading,
			title   : "Voir plus de mot",
			onClick : this.props.onClickChanges
		   } as ButtonFooterItem,
			{
				content : "Ajouter",
				disabled: this.props.loading,
				title   : "Ajouter un mot",
				onClick : this.props.onClickViewPolitique
			} as ButtonFooterItem
		]
		
	}

	private getTableBody(props: PolitiqueCardComponentProps ): JSX.Element {
		if (props.loading) return <tbody><tr><td>Chargement...</td></tr></tbody>
		const approaches = this.props.localAuthority.approaches
		return approaches && approaches.length
			? <tbody>
					{approaches && approaches.length
						? approaches.map((row:any, i) => (
								<tr key={i}>
									<td>
										{/* <Link to={`${props.localAuthority.slug}/glossaries/${row.id}`}> */}
											{row.name}
										{/* </Link> */}
									</td>
								</tr>
							))
						: <tr><td>Aucun mot enregistré</td></tr>}
				</tbody>
			: <tbody><tr><td>Aucun mot enregistré</td></tr></tbody>
	}
}

export default PolitiqueCardComponent 

export interface PolitiqueCardComponentProps  {
	consulted: boolean
	loading: boolean
	localAuthority: LocalAuthority
	onClickViewPolitique(event: React.SyntheticEvent<Element>): void
	onClickChanges(event: React.SyntheticEvent<Element>): void
}


// WEBPACK FOOTER //
// ./src/component/local-authority/local-authority-detail/politique-card/politique-card-component.tsx